/* =========================================================
   CLAMARK READER — FASE 5 FINAL
   Navegación + zoom + arrastre con mouse y dedo
   Archivo: assets/clamark-reader.js
   ========================================================= */

(function () {
  'use strict';

  var IMAGE_SELECTOR = '.clamark-book .clamark-img';
  var OVERLAY_ID = 'clamark-reader-final';

  var images = [];
  var currentIndex = 0;

  var scale = 1;
  var minScale = 1;
  var maxScale = 4;
  var zoomStep = 0.5;

  var translateX = 0;
  var translateY = 0;

  var dragging = false;
  var startX = 0;
  var startY = 0;
  var initialTranslateX = 0;
  var initialTranslateY = 0;

  function addStyles() {
    var previous =
      document.getElementById('clamark-reader-final-css');

    if (previous) {
      previous.remove();
    }

    var style = document.createElement('style');
    style.id = 'clamark-reader-final-css';

    style.textContent = `
      ${IMAGE_SELECTOR} {
        cursor: zoom-in !important;
      }

      #${OVERLAY_ID} {
        position: fixed !important;
        inset: 0 !important;
        z-index: 2147483647 !important;

        display: none !important;
        width: 100vw !important;
        height: 100vh !important;

        margin: 0 !important;
        padding: 0 !important;

        overflow: hidden !important;

        background: #000 !important;
        opacity: 1 !important;
        visibility: visible !important;

        user-select: none !important;
        -webkit-user-select: none !important;
        touch-action: none !important;
      }

      #${OVERLAY_ID}.open {
        display: block !important;
      }

      #${OVERLAY_ID} .clamark-viewer-stage {
        position: absolute !important;
        inset: 0 !important;

        display: flex !important;
        align-items: center !important;
        justify-content: center !important;

        overflow: hidden !important;

        user-select: none !important;
        -webkit-user-select: none !important;
        touch-action: none !important;
      }

      #${OVERLAY_ID} .clamark-viewer-image {
        display: block !important;

        width: auto !important;
        height: auto !important;

        max-width: 92vw !important;
        max-height: 82vh !important;

        margin: 0 !important;
        padding: 0 !important;

        border: 0 !important;
        border-radius: 0 !important;
        box-shadow: none !important;

        object-fit: contain !important;
        background: transparent !important;

        transform-origin: center center !important;
        transform: translate3d(0, 0, 0) scale(1);
        transition: transform .12s ease !important;

        user-select: none !important;
        -webkit-user-select: none !important;
        -webkit-user-drag: none !important;

        touch-action: none !important;
        cursor: grab !important;

        will-change: transform !important;
      }

      #${OVERLAY_ID} .clamark-viewer-image.is-dragging {
        cursor: grabbing !important;
        transition: none !important;
      }

      #${OVERLAY_ID} button {
        font-family: Arial, sans-serif !important;
        user-select: none !important;
        touch-action: manipulation !important;
      }

      #${OVERLAY_ID} .clamark-viewer-close {
        position: fixed !important;
        top: 10px !important;
        right: 10px !important;

        z-index: 2147483647 !important;

        width: 48px !important;
        height: 48px !important;

        margin: 0 !important;
        padding: 0 !important;

        border: 0 !important;
        border-radius: 50% !important;

        background: #fff !important;
        color: #111 !important;

        font-size: 24px !important;
        font-weight: 700 !important;
        line-height: 48px !important;
        text-align: center !important;

        cursor: pointer !important;

        box-shadow:
          0 4px 16px rgba(0, 0, 0, .45) !important;
      }

      #${OVERLAY_ID} .clamark-page-nav {
        position: fixed !important;
        top: 50% !important;

        z-index: 2147483647 !important;

        width: 44px !important;
        height: 44px !important;

        margin: 0 !important;
        padding: 0 !important;

        border: 0 !important;
        border-radius: 50% !important;

        background: #fff !important;
        color: #111 !important;

        font-size: 25px !important;
        font-weight: 700 !important;
        line-height: 44px !important;
        text-align: center !important;

        cursor: pointer !important;

        transform: translateY(-50%) !important;

        box-shadow:
          0 4px 16px rgba(0, 0, 0, .45) !important;
      }

      #${OVERLAY_ID} .clamark-page-prev {
        left: 18px !important;
      }

      #${OVERLAY_ID} .clamark-page-next {
        right: 18px !important;
      }

      #${OVERLAY_ID} .clamark-page-nav:disabled {
        opacity: .25 !important;
        cursor: default !important;
      }

      #${OVERLAY_ID} .clamark-page-counter {
        position: fixed !important;
        left: 50% !important;
        top: 10px !important;

        z-index: 2147483647 !important;

        transform: translateX(-50%) !important;

        padding: 7px 15px !important;
        margin: 0 !important;

        border-radius: 20px !important;

        background: rgba(255, 255, 255, .96) !important;
        color: #111 !important;

        font-family: Arial, sans-serif !important;
        font-size: 14px !important;
        font-weight: 700 !important;
        line-height: 1.2 !important;

        white-space: nowrap !important;

        box-shadow:
          0 4px 16px rgba(0, 0, 0, .40) !important;
      }

      #${OVERLAY_ID} .clamark-viewer-controls {
        position: fixed !important;
        left: 50% !important;
        bottom: 32px !important;

        z-index: 2147483647 !important;

        display: flex !important;
        gap: 10px !important;

        transform: translateX(-50%) !important;

        margin: 0 !important;
        padding: 0 !important;

        background: transparent !important;
      }

      #${OVERLAY_ID} .clamark-viewer-controls button {
        min-width: 44px !important;
        height: 42px !important;

        margin: 0 !important;
        padding: 0 11px !important;

        border: 0 !important;
        border-radius: 24px !important;

        background: #fff !important;
        color: #111 !important;

        font-size: 18px !important;
        font-weight: 700 !important;
        line-height: 42px !important;

        cursor: pointer !important;

        box-shadow:
          0 4px 16px rgba(0, 0, 0, .45) !important;
      }

      body.clamark-reader-open {
        overflow: hidden !important;
        touch-action: none !important;
      }

      @media (max-width: 749px) {
        #${OVERLAY_ID} .clamark-viewer-image {
          max-width: 98vw !important;
          max-height: 76vh !important;
        }

        #${OVERLAY_ID} .clamark-viewer-close {
          top: 8px !important;
          right: 8px !important;

          width: 44px !important;
          height: 44px !important;

          font-size: 22px !important;
          line-height: 44px !important;
        }

        #${OVERLAY_ID} .clamark-page-prev {
          left: 7px !important;
        }

        #${OVERLAY_ID} .clamark-page-next {
          right: 7px !important;
        }

        #${OVERLAY_ID} .clamark-page-counter {
          top: 8px !important;
          padding: 6px 12px !important;
          font-size: 13px !important;
        }

        #${OVERLAY_ID} .clamark-viewer-controls {
          bottom: 24px !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function createViewer() {
    var oldViewer =
      document.getElementById('clamark-lightbox');

    if (oldViewer) {
      oldViewer.remove();
    }

    var existing =
      document.getElementById(OVERLAY_ID);

    if (existing) {
      existing.remove();
    }

    var overlay = document.createElement('div');

    overlay.id = OVERLAY_ID;
    overlay.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');

    overlay.innerHTML = `
      <div class="clamark-viewer-stage">
        <img
          class="clamark-viewer-image"
          src=""
          alt="Página ampliada del libro"
          draggable="false"
        >
      </div>

      <button
        type="button"
        class="clamark-viewer-close"
        aria-label="Cerrar"
      >X</button>

      <button
        type="button"
        class="clamark-page-nav clamark-page-prev"
        aria-label="Página anterior"
      >‹</button>

      <button
        type="button"
        class="clamark-page-nav clamark-page-next"
        aria-label="Página siguiente"
      >›</button>

      <div class="clamark-page-counter">
        Página 1 de 1
      </div>

      <div class="clamark-viewer-controls">
        <button type="button" data-action="out">-</button>
        <button type="button" data-action="reset">1x</button>
        <button type="button" data-action="in">+</button>
      </div>
    `;

    document.body.appendChild(overlay);
  }

  function getElements() {
    var overlay =
      document.getElementById(OVERLAY_ID);

    return {
      overlay: overlay,

      stage: overlay
        ? overlay.querySelector(
            '.clamark-viewer-stage'
          )
        : null,

      image: overlay
        ? overlay.querySelector(
            '.clamark-viewer-image'
          )
        : null,

      close: overlay
        ? overlay.querySelector(
            '.clamark-viewer-close'
          )
        : null,

      previous: overlay
        ? overlay.querySelector(
            '.clamark-page-prev'
          )
        : null,

      next: overlay
        ? overlay.querySelector(
            '.clamark-page-next'
          )
        : null,

      counter: overlay
        ? overlay.querySelector(
            '.clamark-page-counter'
          )
        : null,

      reset: overlay
        ? overlay.querySelector(
            '[data-action="reset"]'
          )
        : null
    };
  }

  function refreshImages() {
    images = Array.prototype.slice.call(
      document.querySelectorAll(
        IMAGE_SELECTOR
      )
    );
  }

  function getPageNumber(image, index) {
    var figure =
      image.closest('[data-page]');

    if (
      figure &&
      figure.getAttribute('data-page')
    ) {
      return figure.getAttribute(
        'data-page'
      );
    }

    return index + 1;
  }

  function getLimits() {
    var elements = getElements();

    if (
      !elements.image ||
      !elements.stage
    ) {
      return {
        x: 0,
        y: 0
      };
    }

    var scaledWidth =
      elements.image.offsetWidth * scale;

    var scaledHeight =
      elements.image.offsetHeight * scale;

    var viewportWidth =
      elements.stage.clientWidth;

    var viewportHeight =
      elements.stage.clientHeight;

    return {
      x: Math.max(
        0,
        (scaledWidth - viewportWidth) / 2
      ),

      y: Math.max(
        0,
        (scaledHeight - viewportHeight) / 2
      )
    };
  }

  function limitMovement() {
    var limits = getLimits();

    translateX = Math.max(
      -limits.x,
      Math.min(limits.x, translateX)
    );

    translateY = Math.max(
      -limits.y,
      Math.min(limits.y, translateY)
    );
  }

  function render(animate) {
    var elements = getElements();

    if (!elements.image) {
      return;
    }

    limitMovement();

    elements.image.style.transition =
      animate === false
        ? 'none'
        : 'transform .12s ease';

    elements.image.style.transform =
      'translate3d(' +
      translateX +
      'px,' +
      translateY +
      'px,0) scale(' +
      scale +
      ')';

    if (elements.reset) {
      elements.reset.textContent =
        scale
          .toFixed(1)
          .replace('.0', '') +
        'x';
    }
  }

  function resetView() {
    scale = 1;
    translateX = 0;
    translateY = 0;
    render(true);
  }

  function updateNavigation() {
    var elements = getElements();

    if (!images.length) {
      return;
    }

    elements.previous.disabled =
      currentIndex <= 0;

    elements.next.disabled =
      currentIndex >= images.length - 1;

    elements.counter.textContent =
      'Página ' +
      getPageNumber(
        images[currentIndex],
        currentIndex
      ) +
      ' de ' +
      images.length;
  }

  function showCurrentImage() {
    var elements = getElements();
    var selected = images[currentIndex];

    if (!selected || !elements.image) {
      return;
    }

    resetView();

    elements.image.src =
      selected.currentSrc ||
      selected.src ||
      '';

    elements.image.alt =
      selected.alt ||
      'Página ampliada del libro';

    elements.image.onload = function () {
      resetView();
    };

    updateNavigation();
  }

  function openViewer(image) {
    refreshImages();

    currentIndex = images.indexOf(image);

    if (currentIndex < 0) {
      currentIndex = 0;
    }

    var elements = getElements();

    showCurrentImage();

    elements.overlay.classList.add(
      'open'
    );

    elements.overlay.setAttribute(
      'aria-hidden',
      'false'
    );

    document.body.classList.add(
      'clamark-reader-open'
    );
  }

  function closeViewer() {
    var elements = getElements();

    dragging = false;

    elements.overlay.classList.remove(
      'open'
    );

    elements.overlay.setAttribute(
      'aria-hidden',
      'true'
    );

    document.body.classList.remove(
      'clamark-reader-open'
    );

    if (elements.image) {
      elements.image.src = '';
      elements.image.classList.remove(
        'is-dragging'
      );
    }

    resetView();
  }

  function previousPage() {
    if (currentIndex <= 0) {
      return;
    }

    currentIndex -= 1;
    showCurrentImage();
  }

  function nextPage() {
    if (
      currentIndex >=
      images.length - 1
    ) {
      return;
    }

    currentIndex += 1;
    showCurrentImage();
  }

  function zoomIn() {
    scale = Math.min(
      maxScale,
      scale + zoomStep
    );

    render(true);
  }

  function zoomOut() {
    scale = Math.max(
      minScale,
      scale - zoomStep
    );

    if (scale === 1) {
      translateX = 0;
      translateY = 0;
    }

    render(true);
  }

  function beginDrag(x, y) {
    if (scale <= 1) {
      return;
    }

    var elements = getElements();

    dragging = true;

    startX = x;
    startY = y;

    initialTranslateX = translateX;
    initialTranslateY = translateY;

    elements.image.classList.add(
      'is-dragging'
    );
  }

  function moveDrag(x, y) {
    if (!dragging) {
      return;
    }

    translateX =
      initialTranslateX +
      (x - startX);

    translateY =
      initialTranslateY +
      (y - startY);

    render(false);
  }

  function finishDrag() {
    if (!dragging) {
      return;
    }

    dragging = false;

    var elements = getElements();

    elements.image.classList.remove(
      'is-dragging'
    );

    render(true);
  }

  function addMouseEvents() {
    var elements = getElements();

    elements.image.addEventListener(
      'mousedown',
      function (event) {
        if (scale <= 1) {
          return;
        }

        event.preventDefault();

        beginDrag(
          event.clientX,
          event.clientY
        );
      }
    );

    document.addEventListener(
      'mousemove',
      function (event) {
        if (!dragging) {
          return;
        }

        event.preventDefault();

        moveDrag(
          event.clientX,
          event.clientY
        );
      }
    );

    document.addEventListener(
      'mouseup',
      function () {
        finishDrag();
      }
    );
  }

  function addTouchEvents() {
    var elements = getElements();

    elements.image.addEventListener(
      'touchstart',
      function (event) {
        if (
          scale <= 1 ||
          event.touches.length !== 1
        ) {
          return;
        }

        event.preventDefault();

        beginDrag(
          event.touches[0].clientX,
          event.touches[0].clientY
        );
      },
      {
        passive: false
      }
    );

    elements.image.addEventListener(
      'touchmove',
      function (event) {
        if (
          !dragging ||
          event.touches.length !== 1
        ) {
          return;
        }

        event.preventDefault();

        moveDrag(
          event.touches[0].clientX,
          event.touches[0].clientY
        );
      },
      {
        passive: false
      }
    );

    elements.image.addEventListener(
      'touchend',
      function () {
        finishDrag();
      },
      {
        passive: false
      }
    );

    elements.image.addEventListener(
      'touchcancel',
      function () {
        finishDrag();
      },
      {
        passive: false
      }
    );
  }

  function prepareImages() {
    refreshImages();

    images.forEach(function (image) {
      image.setAttribute(
        'tabindex',
        '0'
      );

      image.setAttribute(
        'role',
        'button'
      );

      image.setAttribute(
        'aria-label',
        'Tocar para ampliar'
      );
    });
  }

  function addMainEvents() {
    document.addEventListener(
      'click',
      function (event) {
        var image =
          event.target.closest(
            IMAGE_SELECTOR
          );

        if (image) {
          event.preventDefault();
          openViewer(image);
          return;
        }

        if (
          event.target.closest(
            '#' +
            OVERLAY_ID +
            ' .clamark-viewer-close'
          )
        ) {
          closeViewer();
          return;
        }

        if (
          event.target.closest(
            '#' +
            OVERLAY_ID +
            ' .clamark-page-prev'
          )
        ) {
          previousPage();
          return;
        }

        if (
          event.target.closest(
            '#' +
            OVERLAY_ID +
            ' .clamark-page-next'
          )
        ) {
          nextPage();
          return;
        }

        var control =
          event.target.closest(
            '#' +
            OVERLAY_ID +
            ' [data-action]'
          );

        if (control) {
          var action =
            control.getAttribute(
              'data-action'
            );

          if (action === 'in') {
            zoomIn();
          }

          if (action === 'out') {
            zoomOut();
          }

          if (action === 'reset') {
            resetView();
          }
        }
      }
    );

    document.addEventListener(
      'keydown',
      function (event) {
        var elements = getElements();

        var isOpen =
          elements.overlay &&
          elements.overlay.classList.contains(
            'open'
          );

        if (!isOpen) {
          return;
        }

        if (event.key === 'Escape') {
          closeViewer();
        }

        if (event.key === 'ArrowLeft') {
          previousPage();
        }

        if (event.key === 'ArrowRight') {
          nextPage();
        }

        if (
          event.key === '+' ||
          event.key === '='
        ) {
          zoomIn();
        }

        if (event.key === '-') {
          zoomOut();
        }

        if (event.key === '0') {
          resetView();
        }
      }
    );

    window.addEventListener(
      'resize',
      function () {
        render(true);
      }
    );
  }

  function observeImages() {
    if (!window.MutationObserver) {
      return;
    }

    var observer =
      new MutationObserver(
        function () {
          prepareImages();
        }
      );

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

  function init() {
    if (
      !document.querySelector(
        '.clamark-book'
      )
    ) {
      return;
    }

    addStyles();
    createViewer();
    prepareImages();
    addMainEvents();
    addMouseEvents();
    addTouchEvents();
    observeImages();
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }
})();
/* =========================================================
   CLAMARK READER — MÓDULO DE MÚSICA
   Botón play/pausa + loop + volumen bajo
   ========================================================= */

(function () {
  'use strict';

  var OVERLAY_ID = 'clamark-reader-final';
  var BUTTON_ID = 'clamark-music-button';
  var STYLE_ID = 'clamark-music-styles';

  var audio = null;
  var musicButton = null;
  var overlayObserver = null;

  function addMusicStyles() {
    if (document.getElementById(STYLE_ID)) {
      return;
    }

    var style = document.createElement('style');
    style.id = STYLE_ID;

    style.textContent = `
      #${BUTTON_ID} {
  position: fixed !important;
  top: 10px !important;
  left: calc(50% - 105px) !important;
  bottom: auto !important;
  z-index: 2147483647 !important;

  transform: none !important;

  width: 38px !important;
  min-width: 38px !important;
  height: 38px !important;

  margin: 0 !important;
  padding: 0 !important;

  border: 0 !important;
  border-radius: 50% !important;

  background: rgba(255, 255, 255, .96) !important;
  color: #111 !important;

  font-family: Arial, sans-serif !important;
  font-size: 19px !important;
  font-weight: 700 !important;
  line-height: 38px !important;
  text-align: center !important;

  cursor: pointer !important;

  box-shadow:
    0 4px 16px rgba(0, 0, 0, .45) !important;

  touch-action: manipulation !important;
  user-select: none !important;
}
      #${BUTTON_ID}:hover {
  transform: scale(1.06) !important;
}

      #${BUTTON_ID}:focus {
        outline: 3px solid #ffd84d !important;
        outline-offset: 3px !important;
      }

      #${BUTTON_ID}.is-playing {
        background: #fff4b8 !important;
      }

      #${BUTTON_ID}:disabled {
        opacity: .55 !important;
        cursor: not-allowed !important;
      }

      @media (max-width: 749px) {
       #${BUTTON_ID} {
       top: 8px !important;
       left: calc(50% - 96px) !important;
       bottom: auto !important;

       width: 34px !important;
       min-width: 34px !important;
       height: 34px !important;

       padding: 0 !important;

       font-size: 17px !important;
       line-height: 34px !important;
     }
    `;

    document.head.appendChild(style);
  }

  function createAudio() {
    if (audio) {
      return audio;
    }

    if (!window.CLAMARK_MUSIC_URL) {
      console.warn(
        'CLAMARK: no se encontró la URL de la música.'
      );

      return null;
    }

    audio = new Audio(window.CLAMARK_MUSIC_URL);

    audio.loop = true;
    audio.volume = 0.20;
    audio.preload = 'auto';

    audio.addEventListener('play', function () {
      updateButton(true);
    });

    audio.addEventListener('pause', function () {
      updateButton(false);
    });

    audio.addEventListener('error', function () {
      if (musicButton) {
        musicButton.textContent = '⚠ Música no disponible';
        musicButton.disabled = true;
      }
    });

    return audio;
  }

  function updateButton(isPlaying) {
    if (!musicButton) {
      return;
    }

    if (isPlaying) {
      musicButton.textContent = '🔊';
      musicButton.classList.add('is-playing');
      musicButton.setAttribute(
        'aria-label',
        'Pausar música'
      );
    } else {
      musicButton.textContent = '🎵';
      musicButton.classList.remove('is-playing');
      musicButton.setAttribute(
        'aria-label',
        'Reproducir música'
      );
    }
  }

  function toggleMusic(event) {
    event.preventDefault();
    event.stopPropagation();

    var player = createAudio();

    if (!player) {
      return;
    }

    if (player.paused) {
      var playPromise = player.play();

      if (
        playPromise &&
        typeof playPromise.catch === 'function'
      ) {
        playPromise.catch(function () {
          updateButton(false);
        });
      }
    } else {
      player.pause();
    }
  }

  function stopMusic() {
    if (!audio) {
      return;
    }

    audio.pause();

    try {
      audio.currentTime = 0;
    } catch (error) {}

    updateButton(false);
  }

  function createMusicButton() {
    var overlay =
      document.getElementById(OVERLAY_ID);

    if (!overlay) {
      return false;
    }

    var existing =
      document.getElementById(BUTTON_ID);

    if (existing) {
      musicButton = existing;
      return true;
    }

    musicButton =
      document.createElement('button');

    musicButton.id = BUTTON_ID;
    musicButton.type = 'button';
    musicButton.textContent = '🎵';

    musicButton.setAttribute(
      'aria-label',
      'Reproducir música'
    );

    musicButton.addEventListener(
      'click',
      toggleMusic
    );

    overlay.appendChild(musicButton);

    return true;
  }

  function watchOverlayState() {
    var overlay =
      document.getElementById(OVERLAY_ID);

    if (!overlay) {
      return;
    }

    if (overlayObserver) {
      overlayObserver.disconnect();
    }

    overlayObserver =
      new MutationObserver(function () {
        var isOpen =
          overlay.classList.contains('open');

        if (!isOpen) {
          stopMusic();
        }
      });

    overlayObserver.observe(overlay, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function initializeMusic() {
    addMusicStyles();
    createAudio();

    if (createMusicButton()) {
      watchOverlayState();
      return;
    }

    var bodyObserver =
      new MutationObserver(function () {
        if (createMusicButton()) {
          watchOverlayState();
          bodyObserver.disconnect();
        }
      });

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeMusic
    );
  } else {
    initializeMusic();
  }
})();